/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from '../../$$_gendir/node_modules/ngx-toastr/index.ngfactory';
import * as i4 from '../../$$_gendir/node_modules/ngx-bootstrap/popover/popover-container.component.ngfactory';
import * as i5 from '../../$$_gendir/node_modules/ng2-bootstrap/dropdown/bs-dropdown-container.component.ngfactory';
import * as i6 from '../../$$_gendir/node_modules/ng2-bootstrap/modal/modal-backdrop.component.ngfactory';
import * as i7 from '../../$$_gendir/node_modules/ng2-bootstrap/alert/alert.component.ngfactory';
import * as i8 from './components/pages/dashboard/dashboard.component.ngfactory';
import * as i9 from './components/pages/login/login.component.ngfactory';
import * as i10 from './components/pages/register/register.component.ngfactory';
import * as i11 from './components/pages/user/user-list/user-list.component.ngfactory';
import * as i12 from './components/pages/user/user-edit/user-edit.component.ngfactory';
import * as i13 from './components/pages/user/user-create/user-create.component.ngfactory';
import * as i14 from './app.component.ngfactory';
import * as i15 from '@angular/common';
import * as i16 from '@angular/platform-browser';
import * as i17 from '@angular/animations/browser';
import * as i18 from '@angular/platform-browser/animations';
import * as i19 from 'ngx-pagination';
import * as i20 from '@angular/animations';
import * as i21 from '@angular/forms';
import * as i22 from '@angular/http';
import * as i23 from 'ng2-completer/services/local-data';
import * as i24 from 'ng2-completer/services/completer-data-factory';
import * as i25 from 'ng2-completer/services/remote-data';
import * as i26 from 'ng2-completer/services/completer-service';
import * as i27 from 'ngx-toastr';
import * as i28 from 'ngx-bootstrap/popover/popover.config';
import * as i29 from 'ngx-bootstrap/positioning/positioning.service';
import * as i30 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i31 from '@angular/router';
import * as i32 from 'ng2-translate/src/translate.service';
import * as i33 from 'ng2-translate/src/translate.parser';
import * as i34 from 'ng2-bootstrap/positioning/positioning.service';
import * as i35 from 'ng2-bootstrap/component-loader/component-loader.factory';
import * as i36 from 'ng2-bootstrap/dropdown/bs-dropdown.state';
import * as i37 from 'ng2-bootstrap/tabs/tabset.config';
import * as i38 from 'ng2-bootstrap/alert/alert.config';
import * as i39 from '../../app/components/services/rest/auth-rest.service';
import * as i40 from '../../app/services/auth-controller/auth-controller.service';
import * as i41 from '../../app/components/services/rest/cas-backend-rest.service';
import * as i42 from '../../app/components/services/cookie.service';
import * as i43 from '../../app/guards/auth.guard';
import * as i44 from '../../app/components/services/rest/elastic-rest.service';
import * as i45 from 'ng2-completer/ng2-completer.module';
import * as i46 from 'ngx-uploader';
import * as i47 from 'ngx-bootstrap/popover/popover.module';
import * as i48 from '../../app/components/pages/dashboard/dashboard.component';
import * as i49 from '../../app/components/pages/login/login.component';
import * as i50 from '../../app/components/pages/register/register.component';
import * as i51 from '../../app/components/pages/user/user-list/user-list.component';
import * as i52 from '../../app/components/pages/user/user-edit/user-edit.component';
import * as i53 from '../../app/components/pages/user/user-create/user-create.component';
import * as i54 from 'ng2-translate/index';
import * as i55 from 'ng2-bootstrap/dropdown/bs-dropdown.module';
import * as i56 from 'ng2-bootstrap/modal/modal.module';
import * as i57 from 'ng2-bootstrap/collapse/collapse.module';
import * as i58 from 'ng2-bootstrap/tabs/tabs.module';
import * as i59 from 'ng2-bootstrap/alert/alert.module';
import * as i60 from 'angular2-moment/moment.module';
import * as i61 from 'ng2-bootstrap/dropdown/bs-dropdown.config';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.ToastNgFactory,i4.PopoverContainerComponentNgFactory,i5.BsDropdownContainerComponentNgFactory,
              i6.ModalBackdropComponentNgFactory,i7.AlertComponentNgFactory,i8.DashboardPageNgFactory,
              i9.LoginPageNgFactory,i10.RegisterPageNgFactory,i11.UsersPageNgFactory,
              i12.UserPageNgFactory,i13.UserCreatePageNgFactory,i14.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i15.NgLocalization,i15.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
          i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
          i0.ɵl,([] as any[])),i0.ɵmpd(4608,i16.DomSanitizer,i16.ɵe,[i15.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i16.DomSanitizer]),i0.ɵmpd(4608,
              i16.HAMMER_GESTURE_CONFIG,i16.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i16.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i16.ɵDomEventsPlugin(p0_0),new i16.ɵKeyEventsPlugin(p1_0),
                    new i16.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i15.DOCUMENT,i15.DOCUMENT,i15.DOCUMENT,i16.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i16.EventManager,i16.EventManager,[i16.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i16.ɵDomSharedStylesHost,i16.ɵDomSharedStylesHost,
              [i15.DOCUMENT]),i0.ɵmpd(4608,i16.ɵDomRendererFactory2,i16.ɵDomRendererFactory2,
              [i16.EventManager,i16.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i17.AnimationDriver,
              i18.ɵc,([] as any[])),i0.ɵmpd(5120,i17.ɵAnimationStyleNormalizer,i18.ɵd,
              ([] as any[])),i0.ɵmpd(4608,i17.ɵAnimationEngine,i18.ɵb,[i17.AnimationDriver,
              i17.ɵAnimationStyleNormalizer]),i0.ɵmpd(5120,i0.RendererFactory2,i18.ɵe,
              [i16.ɵDomRendererFactory2,i17.ɵAnimationEngine,i0.NgZone]),i0.ɵmpd(6144,
              i16.ɵSharedStylesHost,(null as any),[i16.ɵDomSharedStylesHost]),i0.ɵmpd(4608,
              i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i16.Meta,i16.Meta,
              [i15.DOCUMENT]),i0.ɵmpd(4608,i16.Title,i16.Title,[i15.DOCUMENT]),i0.ɵmpd(4608,
              i19.PaginationService,i19.PaginationService,([] as any[])),i0.ɵmpd(4608,
              i20.AnimationBuilder,i18.ɵBrowserAnimationBuilder,[i0.RendererFactory2,
                  i16.DOCUMENT]),i0.ɵmpd(4608,i21.ɵi,i21.ɵi,([] as any[])),i0.ɵmpd(4608,
              i22.BrowserXhr,i22.BrowserXhr,([] as any[])),i0.ɵmpd(4608,i22.ResponseOptions,
              i22.BaseResponseOptions,([] as any[])),i0.ɵmpd(5120,i22.XSRFStrategy,
              i22.ɵb,([] as any[])),i0.ɵmpd(4608,i22.XHRBackend,i22.XHRBackend,[i22.BrowserXhr,
              i22.ResponseOptions,i22.XSRFStrategy]),i0.ɵmpd(4608,i22.RequestOptions,
              i22.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,i22.Http,i22.ɵc,[i22.XHRBackend,
              i22.RequestOptions]),i0.ɵmpd(5120,i23.LocalData,i24.localDataFactory,
              ([] as any[])),i0.ɵmpd(5120,i25.RemoteData,i24.remoteDataFactory,[i22.Http]),
          i0.ɵmpd(4608,i26.CompleterService,i26.CompleterService,[i23.LocalData,i25.RemoteData]),
          i0.ɵmpd(4608,i27.OverlayContainer,i27.OverlayContainer,([] as any[])),i0.ɵmpd(4608,
              i27.Overlay,i27.Overlay,[i27.OverlayContainer,i0.ComponentFactoryResolver,
                  i0.ApplicationRef]),i0.ɵmpd(4608,i27.ToastrService,i27.ToastrService,
              [i27.TOAST_CONFIG,i27.Overlay,i0.Injector,i16.DomSanitizer]),i0.ɵmpd(4608,
              i28.PopoverConfig,i28.PopoverConfig,([] as any[])),i0.ɵmpd(4608,i29.PositioningService,
              i29.PositioningService,([] as any[])),i0.ɵmpd(4608,i30.ComponentLoaderFactory,
              i30.ComponentLoaderFactory,[i0.ComponentFactoryResolver,i0.NgZone,i0.Injector,
                  i29.PositioningService,i0.ApplicationRef]),i0.ɵmpd(5120,i31.ActivatedRoute,
              i31.ɵf,[i31.Router]),i0.ɵmpd(4608,i31.NoPreloading,i31.NoPreloading,
              ([] as any[])),i0.ɵmpd(6144,i31.PreloadingStrategy,(null as any),[i31.NoPreloading]),
          i0.ɵmpd(135680,i31.RouterPreloader,i31.RouterPreloader,[i31.Router,i0.NgModuleFactoryLoader,
              i0.Compiler,i0.Injector,i31.PreloadingStrategy]),i0.ɵmpd(4608,i31.PreloadAllModules,
              i31.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i31.ROUTER_INITIALIZER,
              i31.ɵi,[i31.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i31.ROUTER_INITIALIZER]),i0.ɵmpd(5120,i32.TranslateLoader,i1.httpFactory,
              [i22.Http]),i0.ɵmpd(4608,i33.TranslateParser,i33.DefaultTranslateParser,
              ([] as any[])),i0.ɵmpd(4608,i32.TranslateService,i32.TranslateService,
              [i32.TranslateLoader,i33.TranslateParser,[2,i32.MissingTranslationHandler]]),
          i0.ɵmpd(4608,i34.PositioningService,i34.PositioningService,([] as any[])),
          i0.ɵmpd(4608,i35.ComponentLoaderFactory,i35.ComponentLoaderFactory,[i0.ComponentFactoryResolver,
              i0.NgZone,i0.Injector,i34.PositioningService]),i0.ɵmpd(4608,i36.BsDropdownState,
              i36.BsDropdownState,([] as any[])),i0.ɵmpd(4608,i37.TabsetConfig,i37.TabsetConfig,
              ([] as any[])),i0.ɵmpd(4608,i38.AlertConfig,i38.AlertConfig,([] as any[])),
          i0.ɵmpd(4608,i39.AuthRESTService,i39.AuthRESTService,[i22.Http,i31.Router]),
          i0.ɵmpd(4608,i40.AuthControllerService,i40.AuthControllerService,[i22.Http,
              i31.Router,i39.AuthRESTService]),i0.ɵmpd(4608,i41.CasBackendRESTService,
              i41.CasBackendRESTService,[i22.Http,i31.Router]),i0.ɵmpd(4608,i42.CookieService,
              i42.CookieService,([] as any[])),i0.ɵmpd(135680,i43.AuthGuard,i43.AuthGuard,
              [i31.Router,i40.AuthControllerService]),i0.ɵmpd(4608,i44.ElasticRESTService,
              i44.ElasticRESTService,[i22.Http]),i0.ɵmpd(512,i15.CommonModule,i15.CommonModule,
              ([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i16.ɵa,([] as any[])),i0.ɵmpd(1024,
              i0.NgProbeToken,() => {
                return [i31.ɵb()];
              },([] as any[])),i0.ɵmpd(512,i31.ɵg,i31.ɵg,[i0.Injector]),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any,p1_0:any) => {
                return [i16.ɵc(p0_0,p0_1),i31.ɵh(p1_0)];
              },[[2,i16.NgProbeToken],[2,i0.NgProbeToken],i31.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i16.BrowserModule,i16.BrowserModule,[[3,i16.BrowserModule]]),
          i0.ɵmpd(512,i19.NgxPaginationModule,i19.NgxPaginationModule,([] as any[])),
          i0.ɵmpd(512,i18.BrowserAnimationsModule,i18.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i21.ɵba,i21.ɵba,([] as any[])),i0.ɵmpd(512,i21.FormsModule,i21.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i22.HttpModule,i22.HttpModule,([] as any[])),
          i0.ɵmpd(512,i45.Ng2CompleterModule,i45.Ng2CompleterModule,([] as any[])),
          i0.ɵmpd(512,i46.NgUploaderModule,i46.NgUploaderModule,([] as any[])),i0.ɵmpd(512,
              i27.ToastrModule,i27.ToastrModule,[[3,i27.ToastrModule]]),i0.ɵmpd(512,
              i47.PopoverModule,i47.PopoverModule,([] as any[])),i0.ɵmpd(1024,i31.ɵa,
              i31.ɵd,[[3,i31.Router]]),i0.ɵmpd(512,i31.UrlSerializer,i31.DefaultUrlSerializer,
              ([] as any[])),i0.ɵmpd(512,i31.ChildrenOutletContexts,i31.ChildrenOutletContexts,
              ([] as any[])),i0.ɵmpd(256,i31.ROUTER_CONFIGURATION,{},([] as any[])),
          i0.ɵmpd(1024,i15.LocationStrategy,i31.ɵc,[i15.PlatformLocation,[2,i15.APP_BASE_HREF],
              i31.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i15.Location,i15.Location,[i15.LocationStrategy]),
          i0.ɵmpd(512,i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i31.ROUTES,() => {
            return [[{path:'',component:i48.DashboardPage,canActivate:[i43.AuthGuard]},
                {path:'login',component:i49.LoginPage},{path:'register',component:i50.RegisterPage},
                {path:'dashboard',component:i48.DashboardPage,canActivate:[i43.AuthGuard]},
                {path:'users',component:i51.UsersPage,canActivate:[i43.AuthGuard],
                    data:{expectedRoles:['sysadmin']}},{path:'user/:id/edit',component:i52.UserPage,
                    canActivate:[i43.AuthGuard],data:{expectedRoles:['sysadmin']}},
                {path:'user/create',component:i53.UserCreatePage,canActivate:[i43.AuthGuard],
                    data:{expectedRoles:['sysadmin']}}]];
          },([] as any[])),i0.ɵmpd(1024,i31.Router,i31.ɵe,[i0.ApplicationRef,i31.UrlSerializer,
              i31.ChildrenOutletContexts,i15.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i31.ROUTES,i31.ROUTER_CONFIGURATION,[2,i31.UrlHandlingStrategy],
              [2,i31.RouteReuseStrategy]]),i0.ɵmpd(512,i31.RouterModule,i31.RouterModule,
              [[2,i31.ɵa],[2,i31.Router]]),i0.ɵmpd(512,i54.TranslateModule,i54.TranslateModule,
              ([] as any[])),i0.ɵmpd(512,i55.BsDropdownModule,i55.BsDropdownModule,
              ([] as any[])),i0.ɵmpd(512,i56.ModalModule,i56.ModalModule,([] as any[])),
          i0.ɵmpd(512,i57.CollapseModule,i57.CollapseModule,([] as any[])),i0.ɵmpd(512,
              i58.TabsModule,i58.TabsModule,([] as any[])),i0.ɵmpd(512,i59.AlertModule,
              i59.AlertModule,([] as any[])),i0.ɵmpd(512,i60.MomentModule,i60.MomentModule,
              ([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[])),
          i0.ɵmpd(256,i27.TOAST_CONFIG,{},([] as any[])),i0.ɵmpd(256,i61.BsDropdownConfig,
              {autoClose:true},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Vzci9zcmMvYXBwL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy91c3Ivc3JjL2FwcC9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts